import { useEffect } from "react";
import { resolveSingleCustomInputChoiceKey, firstTruthy, focusElement } from "./chooserSelection.js";
import { chooserSelectionNeedsInitialization } from "./chooserSubmission.js";
export const useChooserInitialization = ({chooser, hasComposerChooser, initialChooserPage, chooserIdentity, chooserOptionsKey, chooserRecommendedKey, fallbackOptionKey, singleCustomInputChoiceKey, allowsImplicitOptionFallback, chooserPages, normalizedChooserPage, initializedChooserIdentityRef, chooserRef, setChooserPage, setChooserSelectedKey, setChooserCustomInput, setChooserSelections, setChooserCustomInputs}) => {
  useEffect(() => {
    if (!hasComposerChooser) {
      initializedChooserIdentityRef.current = '';
      setChooserPage(1);
      setChooserSelectedKey('');
      setChooserCustomInput('');
      setChooserSelections({});
      setChooserCustomInputs({});
      return;
    }
    setChooserPage(initialChooserPage);
  }, [chooserIdentity, hasComposerChooser, initialChooserPage, initializedChooserIdentityRef, setChooserCustomInput, setChooserCustomInputs, setChooserPage, setChooserSelectedKey, setChooserSelections]);

  useEffect(() => {
    if (!hasComposerChooser) {
      return;
    }
    const preferredSelected = String(firstTruthy(
      chooser.selectedOptionKey,
      singleCustomInputChoiceKey,
      chooserRecommendedKey,
      allowsImplicitOptionFallback ? fallbackOptionKey : '',
    ) ?? '').trim();
    setChooserSelectedKey((current) => (
      current === preferredSelected ? current : preferredSelected
    ));
    setChooserCustomInput((current) => (
      current === '' ? current : ''
    ));
  }, [
    setChooserCustomInput, setChooserSelectedKey,
    allowsImplicitOptionFallback,
    chooserOptionsKey,
    chooserRecommendedKey,
    chooser.key,
    chooser.selectedOptionKey,
    fallbackOptionKey,
    hasComposerChooser,
    singleCustomInputChoiceKey,
  ]);

  useEffect(() => {
    if (!hasComposerChooser || chooser.kind !== 'action_input') {
      return;
    }
    if (!chooserSelectionNeedsInitialization(
      initializedChooserIdentityRef.current,
      chooserIdentity,
    )) {
      return;
    }
    initializedChooserIdentityRef.current = chooserIdentity;
    const pageDefaults = Object.fromEntries(chooserPages.map((page, index) => {
      const customKey = resolveSingleCustomInputChoiceKey(page);
      return [String(index + 1), customKey ? [customKey] : []];
    }));
    setChooserSelections(pageDefaults);
    setChooserCustomInputs({});
  }, [chooser.kind, chooserIdentity, chooserPages, hasComposerChooser, initializedChooserIdentityRef, setChooserCustomInputs, setChooserSelections]);

  useEffect(() => {
    if (hasComposerChooser) {
      focusElement(chooserRef);
    }
  }, [hasComposerChooser, normalizedChooserPage, chooserRef]);

};
